import { DateHelper } from 'app/utility/datehelper';

import { CompanyLookupModel, CompanyLookupDetailsModel } from './../../../models/dms/addressLookup.model';
import { WholesaleSupplierPage } from './../../../pages/wholesale/wholesale-supplier/wholesale-supplier.page';
import { UserService } from 'app/services/user.service';
import { forkJoin, lastValueFrom, Observable } from 'rxjs';
import { FieldUpdateModel } from 'app/models/shared/fieldUpdate.model';
import { GeneralService } from 'app/services/general.service';
import { AddressLookupModel } from 'app/models/dms/addressLookup.model';
import { AddressLookupService } from 'app/services/address-lookup.service';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { DomSanitizer } from '@angular/platform-browser';
import { LookupType, VehicleClass, LookupExternalCollection, SecurityRight, TaxStatusEnum, TimePeriodDropDownType } from 'app/utility/enums';
import { VehicleModel } from 'app/models/dms/vehicle.model';
import { FieldModel } from 'app/models/shared/field.model';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, OnDestroy, Renderer2, input } from '@angular/core';
import { Constants } from 'app/utility/constants';
import { DecimalPipe } from '@angular/common';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ToastController, AlertController, IonSegment, IonSelect, IonInput, NavController, Platform, ModalController } from '@ionic/angular';
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';
import { ModalIframeComponent } from 'app/components/shared/modal-iframe/modal-iframe.component';

import { Browser } from '@capacitor/browser';
import { StringHelper } from 'app/utility/stringhelper';
import { PriceEditorComponent } from '../price-editor/price-editor.component';
import { PriceEditorModel } from 'app/models/shared/priceEditor.model';

@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
    standalone: false
})
export class FieldComponent implements OnInit, OnDestroy
{

    @Input() field: FieldModel;
    @Input() editMode: boolean = false;
    @Input() vehicle: VehicleModel;
    @Input() fieldUpdated: Observable<FieldUpdateModel>;
    @Input() singleColumn: boolean = false;
    private subscriptions: any[] = [];

    @ViewChild('ionInput') ionInput: IonInput;
    @ViewChild('ionSegment') ionSegment: IonSegment;
    @ViewChild('ionSelect') ionSelect: IonSelect;

    @ViewChild('ionTextArea') ionTextArea: IonInput;

    labelIsWrapped: boolean = false;
    isRequiredField: boolean = false;

    active: boolean = false;
    autoGrow: boolean = false;
    isMobile: boolean = false;

    @Output() clicked = new EventEmitter<object>();
    @Output() changed = new EventEmitter<object>();
    @Output() refreshed = new EventEmitter<object>();
    @Output() blurred = new EventEmitter<object>();

    public labelPosition: string = "stacked";
    formattedValue: string = '-';

    uniqueid: string = Math.random().toString(36).substr(2, 9);

    constructor(
        private decimalPipe: DecimalPipe,
        private elRef: ElementRef,
        private renderer: Renderer2,
        public toastController: ToastController,
        public alertController: AlertController,
        public navCtrl: NavController,
        public domSanitizer: DomSanitizer,
        private platform: Platform,
        private modalController: ModalController,
        private ref: ChangeDetectorRef,
        private addressLookupService: AddressLookupService,
        private generalService: GeneralService,
        private userService: UserService
    )
    {
        this.active = true;


    }

    ngOnInit()
    {

        if (this.field.valueChanged$) {
            this.subscriptions.push(
                this.field.valueChanged$.subscribe(x => {
                    this.formatValueForEdit();
                    this.formatValueForView();
                    this.ref.detectChanges();
                })
            );
        }

        this.setId();
        this.formatValueForEdit();
        this.setClasses();
        this.setLabelPosition();
        this.labelIsWrapped = false;

        this.isRequiredField = this.field.required;

        if (this.fieldUpdated)
        {
            this.subscriptions.push(this.fieldUpdated.subscribe(({ id }) => this.fieldChangeEvent(id)));
        }

        this.isMobile = (this.platform.width() < 800);
        const resizeSub = this.platform.resize.subscribe(() =>
        {
            this.isMobile = (this.platform.width() < 800);
            this.ref.detectChanges();
        });
        this.subscriptions.push(resizeSub);

        if (this.field.type == "signature" && this.editMode == true)
        {
            this.field.invalid = !this.fieldIsValid();
        }
        if (this.editMode == true && this.field.editable == true)
        {
            this.field.invalid = !this.fieldIsValid();
        }
        this.setHelperText();

        if (this.field.highlightAssistiveText)
        {
            setTimeout(() =>
            {
                this.field.highlightAssistiveText = false;
            }, 3000);
        }
        this.setThumbnailSrc();

        if (!this.field.editable && this.field.viewInEdit)
        {
            this.editMode = false;
            if (this.editMode && this.field.calculationField)
            {
                this.editMode = true;
            }
        }
        else if (this.editMode)
        {
            this.editMode = true;
        }
        else
        {
            this.editMode = false;
        }

        this.formatValueForView();

        this.previousValue = JSON.parse(JSON.stringify(this.field.value ?? '') ?? '');
        // console.log("field init previous value", this.previousValue);
    }
    previousValue: any;

    ngOnDestroy()
    {
        if (this.subscriptions)
        {
            this.subscriptions.forEach(sub => sub.unsubscribe());
        }
    }

    ngAfterViewInit()
    {
    }

    formatValue(): string
    {
        switch (this.field.type)
        {
            case "date":

                if (this.field.value)
                {
                    return DateHelper.getFormattedDate(<Date>this.field.value);
                }
                else
                {
                    return '-';
                }
            case "datetime":

                if (this.field.value)
                {
                    return DateHelper.getFormattedDateTime(<Date>this.field.value);
                }
                else
                {
                    return '-';
                }
            case "phone":
            case "tel":
                if (this.field.value)
                {
                    const phoneNumber = parsePhoneNumberFromString('' + this.field.value, "NZ");
                    if (phoneNumber && phoneNumber.isValid())
                    {
                        //console.log(phoneNumber.formatInternational());
                        //console.log(phoneNumber.formatNational());
                        //console.log(phoneNumber.getURI());
                        return phoneNumber.formatInternational();
                    }
                    else
                    {
                        return this.field.value;
                    }
                }
                return '-';
                break;
            case "currency":
                return this.formattedValueForEdit;
            case "price":
                return this.formattedValueForEdit;
            case 'boolean':
            case 'toggle':
                return (this.field.value) ? 'Yes' : 'No';
                break;
            case 'segment':
            case 'select':
                if (this.field.detailObject && this.field.value)
                {
                    var value = this.field.detailObject.filter(y => y.id == this.field.value);
                    return (value && value.length > 0) ? value.shift().name : "-";
                }
                return "-";
                break;
            case 'selects':

                var returns: string[] = [];

                var items = this.field.detailObject;
                if (!items) return null;
                var selectedItems = items.filter(
                    (x: ListItemModel) => (this.field.value.indexOf(x.id) >= 0)
                );
                var captions: string[] = [];
                selectedItems.forEach(function (item)
                {
                    captions.push(item.name);
                });
                var selectedValue = captions.join(", ");
                return selectedValue;
                break;
            case 'contact':
                if (this.field.detailObject && this.field.detailObject.displayName)
                {
                    var detail = this.field.detailObject.displayName;
                    return detail;
                }
                else
                {
                    return '-';
                }
                break;
            case 'wholesale-contact':
                if (this.field.detailObject && this.field.detailObject.dealershipTradingDisplayName)
                {
                    return this.field.detailObject.dealershipTradingDisplayName;
                }
                else
                {
                    return '-';
                }
                break;
            case 'part':
                if (this.field.value != null && this.field.detailObject != null && this.field.detailObject.caption != null)
                {

                    return value = this.field.detailObject.caption.toString();
                }
                else return "-";
                break;
            case 'vehicle':
                if (this.field.value != null && this.field.detailObject != null && this.field.detailObject.stockNo != null)
                {

                    return value = this.field.detailObject.stockNo.toString() + " • " + this.field.detailObject.yearManuModelCaption.toString() + " (" + this.field.detailObject.companyCode + ")";
                }
                else return "-";
                break;
            case 'lookup':
                if (this.field.value != null && this.field.detailObject != null && this.field.detailObject.caption != null)
                {

                    var value = this.field.detailObject.caption.toString();
                    return (value != null && value != '') ? value : "-";
                }
                else return "-";
                break;
            case 'lookups':
                var returns: string[] = [];
                if (this.field.detailObject)
                {
                    this.field.detailObject.forEach(
                        (element) =>
                        {
                            returns.push(element.caption)
                        }
                    );
                    return returns.join(', ');
                }
                else
                {
                    return this.field.value.join(", ");
                }
                break;
            case 'html':
                return 'View';
            case 'date-picker':
                const v = this.field.value;
                if (!v || !v.startDate || !v.endDate) return '-';

                const toDate = (d: any): Date | null => {
                    if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
                    if (typeof d === 'string') {
                        const parsed = new Date(d);
                        return isNaN(parsed.getTime()) ? null : parsed;
                    }
                    return null;
                };

                const start = toDate(v.startDate);
                const end = toDate(v.endDate);
                if (!start || !end) return '-';
                return start.toLocaleDateString('en-GB') + ' - ' + end.toLocaleDateString('en-GB');
            case 'richtext':
            // TODO: Implement
            default:
                var s = this.field.value ? this.field.value.toString() : "";
                if (s)
                {
                    return s;
                }
                else
                {
                    return '-';
                }
        }
    }

    getSafeHtmlValue(): any
    {
        //console.log(this.field.value);
        var html = this.domSanitizer.bypassSecurityTrustHtml(this.field.value);
        return html;
    }

    getSafeUrlValue(): any
    {
        var url = this.domSanitizer.bypassSecurityTrustResourceUrl(this.field.detailObject);
        return url;
    }

    async loadSandboxedHtml()
    {
        var content = this.field.value;
        content += '<style>table.main-container { margin: 0 auto; width: 100%; } </style>';

        const modal = await this.modalController.create({
            component: ModalIframeComponent,
            componentProps: {
                title: this.field.label,
                html: content,
                buttons: [
                    {
                        text: 'Close',
                        role: 'cancel',
                        cssClass: 'secondary'
                    }
                ],
                light: true,
            },
            cssClass: 'html-modal'
        });
        await modal.present();
        await modal.onDidDismiss();
    }


    private formatValueForView() {
        let formattedValue = this.formatValue();
        if (formattedValue) {
            this.formattedValue = formattedValue;
        }
    }

    priceEditorObject: PriceEditorModel;
    taxStatuses: ListItemModel[];//get full list of tax statuses
    priceTaxTypeLabel: string;

    async formatValueForEdit()
    {
        switch (this.field.type)
        {
            case "date":
            case "datetime":

                if (DateHelper.dateIsValid(this.field.value))
                {
                    this.formattedValueForEdit = DateHelper.toISOString(this.field.value);
                    this.formattedValueForEditDate = DateHelper.formatForDateTimeInput(this.formattedValueForEdit);
                }
                else
                {
                    this.formattedValueForEdit = null;
                    this.formattedValueForEditDate = null;
                }
                this.dateFormat = (this.field.type == "date") ? "dd MMM yyyy" : "dd MMM yyyy HH:mm";
                break;
            case "stars":
                this.emptyStars = this.field.detailObject;
                this.fullStars = 0;

                var totalHalfStars = this.field.value;
                if (totalHalfStars >= 0)
                {
                    this.fullStars = Math.floor(totalHalfStars / 2);
                    this.halfStar = totalHalfStars % 2 != 0;
                    this.emptyStars -= this.fullStars;
                    if (this.halfStar)
                    {
                        this.emptyStars--;
                    }
                }
            case "contact":
                if (this.field.detailObject && this.validPhone(this.field.detailObject.mobile))
                {
                    this.field.sublabel = this.field.detailObject.mobile;
                }
                if (this.field.detailObject && this.field.detailObject.primaryEmail)
                {
                    this.field.sublabel = (this.field.sublabel ? this.field.sublabel + " • " : "") + this.field.detailObject.primaryEmail;
                }
                break;
            case "price":
                await this.formatPriceField(this.field.value);
                break;
            case 'number':
            case 'decimal':
                if (this.field.value != null && this.field.value == '-1')
                {
                    this.formattedValueForEdit = null;
                }
                else
                {
                    this.formattedValueForEdit = this.field.value;
                }
                break;
            case "currency":
                this.formatCurrencyField(this.field.value);
                break;
            case 'date-picker':
                break;
            default:
                this.formattedValueForEdit = this.field.value;
                break;
        }
    }
    fullStars: number = 0;
    halfStar: boolean = false;
    emptyStars: number = 0;

    formattedValueForEdit: string;
    formattedValueForEditDate: string;
    dateFormat: string;
    setId()
    {
        this.id = '';
        if (this.field.id)
        {
            this.id = this.field.id;
        }
        else if (this.field.label)
        {
            this.id = "app-field-" + this.field.label.toLowerCase().replace(/\s/g, '');
        }
    }
    id: string = "";

    async focusInput(ev: any)
    {
        if (this.ionInput) this.ionInput.setFocus();
    }

    toggleLabelWrap(ev: any)
    {
        if (this.field.detail) return;
        this.labelIsWrapped = !this.labelIsWrapped;
    }

    async handleClick(ev: any)
    {
        //send the parent FieldGroupComponent the event via our clicked EventEmitter
        var params = {
            "detail": this.field
        };
        // console.log("Field Clicked", params);
        if (!this.editMode || this.field.type == "url")
        {
            switch (this.field.type)
            {
                case "html":
                    this.loadSandboxedHtml();
                    break;
                case "tel":
                    if (this.field.value)
                    {
                        var phoneNumber = parsePhoneNumberFromString(this.field.value, "NZ");
                        if (phoneNumber.isValid())
                        {
                            const url = phoneNumber.getURI();
                            window.location.href = url;
                        }
                    }
                    break;
                case "address":
                    //console.log(this.field.value);
                    if (this.field.value)
                    {
                        var address = encodeURI(this.field.value.replace(/\n/g, ", "));
                        let url = '';
                        if (this.platform.is("android"))
                        {
                            url = 'geo:0,0?q=' + address;
                            window.location.href = url;
                        }
                        else if (this.platform.is("ios"))
                        {
                            url = 'maps://?q=' + address;
                            window.location.href = url;
                        }
                        else
                        {
                            url = 'https://www.google.co.nz/maps/place/' + address;
                            await Browser.open({ url });
                        }
                    }
                    break;
                case "email":
                    if (this.field.value)
                    {
                        const url = 'mailto:' + this.field.value;
                        window.location.href = url;
                    }
                    break;
                case "url":
                case "link":
                    if (this.field.value && this.field.detailObject)
                    {
                        await Browser.open({ url: this.field.detailObject, });
                    }
                    else if (this.field.value)
                    {
                        await Browser.open({ url: this.field.value, });
                    }
                    break;
                case "path":
                    // console.log(this.field);
                    this.navCtrl.navigateForward(this.field.detailObject);
                    break;
                case "contact":
                    // console.log(this.field);
                    if (this.field.value && this.showDetail() && !this.editMode)
                    {
                        if (this.userService.hasUserRight(SecurityRight.ContactTabs))
                        {
                            this.navCtrl.navigateForward('/contacts/' + this.field.value);
                        }
                    }
                    break;
                case "vehicle":
                    if (this.field.value && this.showDetail() && !this.editMode)
                    {
                        this.navCtrl.navigateForward('/vehicles/' + this.field.value);
                    }
                    break;
            }
        }

        this.clicked.emit(params);

        //this is the alternative option - we can bubble up through multiple components
        //this is a bit of an antipattern though
        // this.renderer.invokeElementMethod(
        //   this.elRef.nativeElement,
        //   'dispatchEvent',
        //   [new CustomEvent("fieldComponentClicked", {
        //     bubbles: true,
        //     detail: params
        //   })]
        // );

    }

    handleButtonClicked(event: any)
    {
        if (event)
        {
            event.stopPropagation();
        }
        
        let field = {
            ...this.field
        };

        field.buttonClickedEvent = true;

        var params = {
            "detail": field
        };

        this.clicked.emit(params);
    }

    async fieldChanged(ev: any)
    {
        // console.log("fieldChanged", ev);
        var value: any;

        if (this.editMode && this.field.serverValidationClasses)
        {
            //remove server validation class from this.classes
            this.classes = this.classes.replace(this.field.serverValidationClasses.trim(), '');
            this.ref.detectChanges();
        }

        switch (this.field.type)
        {
            case "lookup":
            case "select":
            case "selects":
            case "lookups":
            case "richtext":
                value = ev;
                break;
            case "segment":
                value = ev.detail.value;
                break;
            case "signature":
                value = ev;
                break;
            case "toggle":
                value = ev.detail.checked;
                break;
            case "currency":
                value = this.formatCurrencyField(ev.detail.value);
                break;
            case "decimal":
                value = parseFloat(ev.detail.value);
                if (!value) value = 0;
                break;
            case "price":
                value = await this.formatPriceField(ev.detail.value, true);
                break;
            case "number":
                value = parseInt(ev.detail.value);
                if (!value) value = 0;
                break;
            case "vehicle":
                value = ev.vehicleId;
                break;
            case "contact":
                if (ev.contactId)
                {
                    value = ev.contactId;
                }
                else
                {
                    value = ev.id;
                }
                break;
            case "photo":
                value = ev;
                break;
            case "autocomplete":
                value = ev.detail.value;
                break;
            case "autocomplete-company":
                value = ev.detail.value;
                break;
            case "datetime":
            case "time":
            case "date":
                value = DateHelper.convertToUTC(ev.detail.value);
                break;
            case 'date-picker':
                // Handled via onDatePickerChanged; ignore generic processing
                return;
            default:
                value = ev.detail.value;
                break;
        }

        //console.log("previousValue", this.previousValue);
        if (value != this.previousValue || this.field.dirty)
        {

            this.field.dirty = true;
            this.field.value = value;
            this.field.invalid = !this.fieldIsValid();
            //console.log("value changed ", this.field);
            var params = {
                "detail": {
                    id: this.field.id,
                    field: this.field,
                    value: value,
                    event: ev
                }
            };
            //console.log("Field Changed", params);
            this.changed.emit(params);

            if (this.field.type == "autocomplete" && !this.autoCompleteSet)
            {
                this.autoCompleteSearch(this.field.value);
            }
            if (this.field.type == "autocomplete-company" && !this.companyAutoCompleteSet)
            {
                this.autoCompleteCompanySearch(this.field.value);
            }
            if (this.field.type == "date" || this.field.type == "datetime")
            {
                this.formatValueForEdit();
            }
        }




        //Bubble up alternative (if you need to access the event outside of the modal edit)
        // this.renderer.invokeElementMethod(
        //   this.elRef.nativeElement,
        //   'dispatchEvent',
        //   [new CustomEvent("fieldComponentChanged", {
        //     bubbles: true,
        //     detail: params
        //   })]
        // );
    }

    fieldBlurred(ev: any)
    {
        var params = {
            "detail": {
                id: this.field.id,
                field: this.field,
                value: this.field.value,
                event: ev
            }
        };
        this.blurred.emit(params);
    }

    setClasses(returnFieldType: boolean = true)
    {
        this.classes = (this.editMode ? "edit " : "readonly ");
        this.classes += (returnFieldType ? this.field.type + ' ' : '');
        this.classes += (this.field.viewInEdit && !this.field.editable ? "readonly " : "");
        this.classes += (this.field.selected ? "selected " : "") + this.field.classes;
        if (this.field.value)
        {
            this.classes += ' field-has-value';
        }
        if (this.field.serverValidationClasses && this.classes.indexOf(this.field.serverValidationClasses) == -1)
        {
            this.classes += ' ' + this.field.serverValidationClasses;
        }
    }
    classes: string = "";

    ionInputType()
    {
        switch (this.field.type)
        {
            case "password":
            case "email":
            case "tel":
            case "url":
            case "link":
            case "date":
            case "datetime":
            case "autocomplete":
            case "autocomplete-company":
            case "text":
            case "richtext":
                return this.field.type;
                break;
            case "currency":
            case "price":
                return "text";
            case "number":
            case "decimal":
                return "number";
                break;
            case "string":
            default:
                console.error("invalid field type, " + this.field.type);
                break;
        }
    }

    public isFieldType(type: string): boolean
    {
        switch (type)
        {
            case "numeric":
                return (this.field.type == 'number' || this.field.type == 'decimal' || this.field.type == 'currency');
                break;
            case "text":
                return (this.field.type == 'text');
                break;
            default:
                return this.field.type == type;
        }

    }

    public ionInputMode(): string
    {
        switch (this.field.type)
        {
            case "number":
                return "numeric";
                break;
            case "decimal":
            case "currency":
                return "decimal";
            case "price":
                return "text";
                break;
            case "autocomplete":
            case "autocomplete-company":
                return "text";
                break;
            case "url":
            case "link":
                return "url";
                break;
            case "email":
                return "email";
                break;
            case "tel":
                return "tel";
                break;
            default:
                return this.field.type;
                break;
        }
    }

    public fieldPattern(): string
    {
        switch (this.field.type)
        {
            case "email":
                return "[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})";
                break;
        }
    }

    async errorIconClicked(ev: any)
    {
        var message = "The value of this field is not valid";
        if (this.field.value == '' && this.field.required)
        {
            message = "This field requires a value";
        }
        const alert = await this.alertController.create({
            // header: title,
            message: message,
            buttons: [
                {
                    text: 'OK',
                    role: 'cancel',
                    cssClass: 'danger',
                    handler: () =>
                    {

                    }
                }
            ]
        });

        await alert.present();
    }

    public fieldIsValid()
    {
        if (!this.field.editable)
        {
            return true;
        }

        switch (this.field.type)
        {
            case "date":
                if (DateHelper.dateIsValid(this.field.value)) return true;
                break;
            case "datetime":
                if (DateHelper.dateTimeIsValid(this.field.value)) return true;
                break;
            case "email":
                if (this.field.value)
                {
                    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                    return re.test(String(this.field.value).toLowerCase());
                }
                break;
            case "tel":
                if (this.field.value)
                {
                    const phoneNumber = parsePhoneNumberFromString(this.field.value, "NZ");
                    if (phoneNumber) return phoneNumber.isValid();
                    else return false;
                }
                break;
            case "number":
            case "currency":
            case "price":
            case "decimal":
                if (this.field.value != null && (this.field.value != '' || this.field.value === 0))
                {
                    // console.log(this.field.id, this.field.value, this.field);
                    return !isNaN(this.field.value.toString());
                }
                else if (this.field.required)
                {
                    return false;
                }
                break;
            case 'boolean':
            case 'toggle':
                if (this.field.required && !this.field.value) return false;
                else return true;
                break;
            case 'lookup':
                if (this.field.required && this.field.detailObject)
                {
                    if (this.field.detailObject.lookupType == LookupType.Internal && !this.field.useIdsInInternalLookup)
                    {
                        // console.log(this.field.id, "is internal lookup", this.field.value);
                        return (this.field.value != null && (this.field.value != 0 || this.field.detailObject.caption));
                    }
                    else
                    {
                        // console.log(this.field.id, "is external lookup");
                        return (this.field.value != null && this.field.value != Constants.EmptyGuid);
                    }
                }
                break;
            case 'segment':
                var segmentedValue = this.field.detailObject.filter(y => y.id == this.field.value);
                if (this.field.required && this.field.detailObject)
                {
                    return (segmentedValue && segmentedValue.length > 0);
                }
                break;
            case 'select':
                if (this.field.required && this.field.detailObject)
                {
                    var segmentedValue = this.field.detailObject.filter(y => y.id == this.field.value);
                    return (segmentedValue && segmentedValue.length > 0);
                }
                break;
            case 'company':
            case 'contact':
            case 'vehicle':
                //  console.log(this.field.id, this.field.value);
                if (this.field.value != '' && this.field.value != null && this.field.value != Constants.EmptyGuid)
                {

                    return true;
                }
                else if (this.field.required)
                {
                    return false;
                }
                break;
            case "photo":
            case "signature":
                if (this.field.value != '' && this.field.value != null)
                {
                    // console.log(this.field.value);
                    return true;
                }
                break;
            case 'date-picker':
                const v = this.field.value;
                if (!v) return !this.field.required;
                const valid = (v.startDate instanceof Date || typeof v.startDate === 'string')
                           && (v.endDate instanceof Date || typeof v.endDate === 'string');
                if (!this.field.required) return valid ? true : false;
                return valid;
        }
        //return true for empty, non-required fields
        if (!this.field.value || this.field.value == '')
        {
            return (this.field.required && this.field.editable) ? false : true;
        }

        if (this.field.required && !this.field.value && this.field.editable)
        {
            return false;
        }

        //return true by default as it's probably text
        return true;
    }

    public separateLabel(): boolean
    {
        switch (this.field.type)
        {
            case 'segment':

                return true;
                break;
            default:
                return false;
        }
    }

    public isEditable(): boolean
    {
        return this.field.editable;
    }

    public showDetail(): boolean
    {
        // console.log(this.field);
        if (this.field.type == "contact")
        {
            return (this.field.detailObject && (this.field.detailObject.contactType == "Customer" || this.field.detailObject.contactType == "Supplier" || this.field.detailObject.contactType == "User") && this.field.detailObject.id && this.field.detailObject.id != Constants.EmptyGuid && !this.editMode);
        }
        if (this.field.type == "wholesale-contact")
        {
            return (this.field.detailObject && this.field.detailObject.dealershipID && this.field.detailObject.dealershipID != 0 && !this.editMode);
        }
        if (this.field.type == "vehicle")
        {
            return (this.field.detailObject && this.field.detailObject.vehicleId && this.field.detailObject.vehicleId != Constants.EmptyGuid && !this.editMode);
        }

        return this.field.detail;
    }

    public refreshField(ev: any)
    {
        // console.log("refreshing field", this.field);
        var params = {
            "detail": {
                refresh: true
            }
        };

        this.refreshed.emit(params);
    }


    editSignaturePad()
    {
        this.signatureIsEditing = true;
    }
    signatureIsEditing: boolean = false;

    thumbnailSrc: string = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    useBearerToken: boolean = true;
    setThumbnailSrc()
    {
        if (this.field.detailObject)
        {
            switch (this.field.type)
            {
                case "vehicle":
                    if (this.field.detailObject.vehicleThumbnailUrl)
                    {
                        this.thumbnailSrc = this.field.detailObject.vehicleThumbnailUrl;
                        this.useBearerToken = this.thumbnailSrc.startsWith(Constants.ApiUrl);
                    }
                    else if (this.field.detailObject)
                    {
                        this.thumbnailSrc = Constants.ApiUrl + "Vehicles/" + this.field.detailObject.vehicleId + "/Thumbnail?t=" + this.field.detailObject.modifiedDate;
                    }
            }
        }
    }

    getInitials(name: string = ''): string
    {
        return StringHelper.getInitials(name);
    }



    async viewImage()
    {
        if (this.field.showPlaceholder || !this.field.value || this.field.disableViewer) return;

        const modal = await this.modalController.create({
            component: ImageViewerComponent,
            componentProps: {
                imgSources: [this.field.value],
                imgTitle: this.field.label,
                imgDescription: ''
            },
            cssClass: '       ',
            keyboardClose: true,
            showBackdrop: true
        });

        return await modal.present();
    }

    async viewWholesaleContact()
    {
        if (this.field.showPlaceholder || !this.field.value) return;

        const modal = await this.modalController.create({
            component: WholesaleSupplierPage,
            componentProps: {
                imgSources: [this.field.value],
                imgTitle: this.field.label,
                imgDescription: ''
            },
            cssClass: '       ',
            keyboardClose: true,
            showBackdrop: true
        });

        return await modal.present();
    }

    getFieldValue(): string
    {
        // console.log("getfieldvalue", this.field.value);
        return this.field.value;
    }

    autocompletes: AddressLookupModel[];
    autoCompleteSearchActive: boolean = false;

    async autoCompleteSearch(search: any)
    {
        if (this.autoCompleteSearchActive) return;

        if (search.length > 3)
        {
            this.autoCompleteSearchActive = true;
            this.addressLookupService.getResults(search).subscribe(
                x =>
                {
                    this.autoCompleteSearchActive = false;
                    this.autocompletes = x;

                    this.ref.markForCheck();
                }
            );
        }
    }

    autoCompleteSet: boolean = false;
    autoCompleteSelected(autocomplete: AddressLookupModel)
    {
        // console.log("autocompleteselected", autocomplete);
        var value = (autocomplete.street_number + ' ' + autocomplete.street).trim();
        if (this.field.value != value)
        {
            this.field.value = value;
            this.autoCompleteSet = true;
        }

        var params = {
            "detail": {
                id: this.field.id,
                field: this.field,
                value: this.field.value,
                event: null
            },
            autocomplete: autocomplete
        };

        this.autocompletes = [];

        this.generalService.findOrCreateExternalLookupCached(autocomplete.city, VehicleClass.None, LookupExternalCollection.LocationCity, Constants.EmptyGuid).subscribe({
            next: x =>
            {
                autocomplete.cityObject = x;
                this.changed.emit(params);

                setTimeout(() =>
                {
                    this.autoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            },
            error: err =>
            {
                this.changed.emit(params);
                setTimeout(() =>
                {
                    this.autoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            }
        });


    }

    async hideAutoComplete()
    {
        setTimeout(() =>
        {
            this.autocompletes = [];
            this.companyAutoCompletes = [];
            this.autoCompleteActiveIndex = -1;
            this.ref.markForCheck();
        }, 500);
    }

    companyAutoCompletes: CompanyLookupModel[];
    companyAutoCompleteSearchActive: boolean = false;

    async autoCompleteCompanySearch(search: any)
    {
        if (this.companyAutoCompleteSearchActive)
        {
            // console.log("returning as autocomplete search is active");
            return;
        }

        if (search.length > 3)
        {
            this.companyAutoCompleteSearchActive = true;
            this.addressLookupService.getCompanyResults(search).subscribe({
                next: x =>
                {
                    this.companyAutoCompleteSearchActive = false;
                    this.companyAutoCompletes = x;

                    this.ref.markForCheck();
                },
                error: err =>
                {
                    this.companyAutoCompleteSearchActive = false;
                    return;
                }
            });
        }
    }

    companyAutoCompleteSet: boolean = false;
    companyAutoCompleteSelected(autocomplete: CompanyLookupModel)
    {
        this.companyAutoCompleteSearchActive = true;
        this.companyAutoCompletes = [];
        this.field.value = autocomplete.name;
        this.addressLookupService.getCompanyDetails(autocomplete.nzbn).subscribe({
            next: x =>
            {
                setTimeout(() =>
                {
                    this.companyAutoCompleteSearchActive = false;
                }, 1000);

                this.companyAutoCompleteSelectedDetails(x);
                this.ref.markForCheck();
            },
            error: err =>
            {
                this.companyAutoCompleteSearchActive = false;
                return;
            }
        });
    }
    companyAutoCompleteSelectedDetails(autocomplete: CompanyLookupDetailsModel)
    {
        //console.log("companyAutoCompleteSelected", autocomplete);
        var value = (autocomplete.name).trim();
        if (this.field.value != value)
        {
            this.field.value = value;
            this.companyAutoCompleteSet = true;
        }

        var params = {
            "detail": {
                id: this.field.id,
                field: this.field,
                value: this.field.value,
                event: null
            },
            autocomplete: autocomplete
        };

        this.companyAutoCompletes = [];

        this.companyAutoCompleteSet = false;

        this.generalService.findOrCreateExternalLookupCached(autocomplete.physicalAddress.city, VehicleClass.None, LookupExternalCollection.LocationCity, Constants.EmptyGuid).subscribe({
            next: x =>
            {
                autocomplete.physicalAddress.cityObject = x;
                this.changed.emit(params);

                setTimeout(() =>
                {
                    this.companyAutoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            },
            error: err =>
            {
                this.changed.emit(params);
                setTimeout(() =>
                {
                    this.companyAutoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            }
        });

        this.generalService.findOrCreateExternalLookupCached(autocomplete.postalAddress.city, VehicleClass.None, LookupExternalCollection.LocationCity, Constants.EmptyGuid).subscribe({
            next: x =>
            {
                autocomplete.postalAddress.cityObject = x;
                this.changed.emit(params);

                setTimeout(() =>
                {
                    this.companyAutoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            },
            error: err =>
            {
                this.changed.emit(params);
                setTimeout(() =>
                {
                    this.companyAutoCompleteSet = false;
                    this.ref.markForCheck();
                }, 1000);
            }
        });

    }

    setLabelPosition()
    {
        switch (this.field.type)
        {
            case 'toggle':
            case 'checkbox':
            case 'boolean':
            case 'segment':
                this.labelPosition = "inline";
                break;

            case "phone":
            case "tel":
            case "currency":
            case "price":
            case "number":
            case "email":
            case "url":
            case "text":
            case 'longtext':
            case 'date':
            case 'datetime':
            case 'autocomplete':
            case 'autocomplete-company':
            case 'richtext':
                this.labelPosition = "floating";
                break;

            // case "date":
            // case "datetime":
            // case 'date-picker':
            default:
                this.labelPosition = "stacked";
        }

    }
    helperText: string = '';
    setHelperText()
    {
        if (this.field.errorMessage)
        {
            this.helperText = this.field.errorMessage;
            return;
        }
        switch (this.field.type)
        {


            case "phone":
            case "tel":
                this.helperText = "Please set " + this.field.label.toLowerCase() + ' (must be a valid phone number)';
                break;

            case "email":
                this.helperText = "Please set " + this.field.label.toLowerCase() + ' (must be a valid email)';
                break;

            case 'toggle':
            case 'checkbox':
            case 'boolean':
            case "lookups":
            case "selects":
                this.helperText = "Please select " + this.field.label.toLowerCase() + '';

            case "date":
            case "datetime":
            case 'date-picker':
            case "select":
            case "lookup":
            case "contact":
            case "company":
            case "vehicle":
                this.helperText = "Please select a " + this.field.label.toLowerCase() + '';

            case "currency":
            case "number":
            case "decimal":
            case "price":
            case "text":
            case "richtext":
            default:
                this.helperText = "Please set " + this.field.label.toLowerCase() + '';
                break;
        }

    }

    activated: boolean = false;
    async fieldClick()
    {
        this.activated = true;
        // console.log(this.field);
        if (this.field.type == "longtext")
        {
            setTimeout(() =>
            {
                this.ionTextArea.setFocus();
            }, 50);
        }


    }

    fieldChangeEvent(id: string)
    {
        if (id == this.field.id ||
            id == this.field.parent ||
            (this.field.calculationField && this.field.calculationFields.includes(id)))
        {
            setTimeout(() =>
            {
                this.formatValueForEdit();
                this.formatValueForView();
                this.ref.detectChanges();
                this.ref.markForCheck();
            }, 0);
        }
    }

    public validPhone(phone: string): boolean
    {
        if (!phone) return false;

        var phoneNumber = parsePhoneNumberFromString(phone, "NZ");
        if (phoneNumber && phoneNumber.isValid())
        {
            return true;
        }
    }

    public async openPriceEditor(ev: any)
    {

        ev.stopPropagation();
        ev.preventDefault();

        var priceEditorData = this.field.detailObject as PriceEditorModel;

        var mode = 'simple';
        if (priceEditorData.mode == 'extended' ||
            (priceEditorData.mode != 'simple' && priceEditorData.taxRate && priceEditorData.currency && priceEditorData.taxType && priceEditorData.taxAmount))
        {
            mode = 'extended';
        }

        const modal = await this.modalController.create({
            component: PriceEditorComponent,
            componentProps: {
                title: this.field.label || 'Price editor',
                mode: mode,
                removeTaxTypes: priceEditorData.removeTaxTypes,
                editableCurrency: priceEditorData.editableCurrency,
                editableTaxRate: priceEditorData.editableTaxRate,
                //simple (and extended)
                price: this.field.value,
                taxType: priceEditorData.taxType?.value,
                //extended
                taxRate: priceEditorData.taxRate?.value,
                taxAmount: priceEditorData.taxAmount?.value,
                currency: priceEditorData.currency?.value,
            }
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();

        if (data && data.result && data.result.save)
        {

            this.field.dirty = true;

            this.field.value = data.result.price;
            priceEditorData.price.value = data.result.price;
            priceEditorData.taxType.value = data.result.taxType.id;
            this.priceTaxTypeLabel = this.taxStatuses.find(x => x.id == data.result.taxType.id)?.name || ""

            if (mode == 'extended')
            {
                priceEditorData.taxRate.value = data.result.taxRate;
                priceEditorData.taxAmount.value = data.result.taxAmount;
                priceEditorData.currency.value = data.result.currency;
            }

            this.ref.detectChanges();
            this.fieldChanged({ detail: { value: this.field.value } });

        }
    }

    autoCompleteActiveIndex: number = -1;

    onAutoCompleteKeydown(event: KeyboardEvent)
    {
        let list: any[] = [];
        if (this.field.type === 'autocomplete')
        {
            list = this.autocompletes || [];
        } else if (this.field.type === 'autocomplete-company')
        {
            list = this.companyAutoCompletes || [];
        } else
        {
            return;
        }

        if (!list.length) return;

        if (event.key === 'ArrowDown')
        {
            event.preventDefault();
            this.autoCompleteActiveIndex = (this.autoCompleteActiveIndex + 1) % list.length;
            this.ref.markForCheck();
        } else if (event.key === 'ArrowUp')
        {
            event.preventDefault();
            this.autoCompleteActiveIndex = (this.autoCompleteActiveIndex - 1 + list.length) % list.length;
            this.ref.markForCheck();
        } else if (event.key === 'Enter')
        {
            event.preventDefault();
            if (this.autoCompleteActiveIndex >= 0 && this.autoCompleteActiveIndex < list.length)
            {
                if (this.field.type === 'autocomplete')
                {
                    this.autoCompleteSelected(list[this.autoCompleteActiveIndex]);
                } else if (this.field.type === 'autocomplete-company')
                {
                    this.companyAutoCompleteSelected(list[this.autoCompleteActiveIndex]);
                }
            }
        } else
        {
            this.autoCompleteActiveIndex = -1;
        }
    }

    formatCurrencyField(incomingValue: any)
    {
        let newValue = parseFloat(incomingValue?.toString().replace(/[^0-9.-]/g, ''));
        if (isNaN(newValue)) newValue = 0;
        this.formattedValueForEdit = newValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (this.ionInput) {
            this.ionInput.value = this.formattedValueForEdit;
        }
        this.formattedValue = this.formattedValueForEdit;
        return newValue.toFixed(2);
    }

    async formatPriceField(incomingValue: string, isDirtyOverride: boolean = false): Promise<number | null> {
        var { taxStatuses, baseCurrency, currencies } = await lastValueFrom(
            forkJoin({
                baseCurrency: this.generalService.getCachedBaseCurrency(),
                currencies: this.generalService.getCachedCurrencies(),
                taxStatuses: this.generalService.getCachedTaxStatuses(false)
            })
        );

        this.taxStatuses = taxStatuses.map(v => new ListItemModel(v.taxStatusEnum.toString(), v.name.toString(), v.reference, null, v));


        if (isDirtyOverride) this.field.dirty = true;
        if (this.field.detailObject.removeTaxTypes)
        {
            taxStatuses = taxStatuses.filter(x => x.name != TaxStatusEnum.Auction && x.name != TaxStatusEnum.Tender && x.name != TaxStatusEnum.POA);
        }
        const { incomingCurrencyCode, incomingAmount, incomingTaxTypeCode } = this.parseCurrencyTaxInput(incomingValue.toString());

        var incomingCurrencyObject = incomingCurrencyCode ? currencies.find(x => x.reference == incomingCurrencyCode) : null;
        var incomingAmountValue = this.field.allowZero ? (incomingAmount || 0) : (incomingAmount || null);
        var incomingTaxType = incomingTaxTypeCode ? taxStatuses.find(x => x.reference.toUpperCase() == incomingTaxTypeCode.toUpperCase()) : null;

        var currentCurrency = this.field.detailObject?.currency?.value ? currencies.find(x => x.currencyId == this.field.detailObject.currency.value) : null;
        var currentTaxType = this.field.detailObject?.taxType?.value ? taxStatuses.find(x => x.taxStatusEnum == this.field.detailObject.taxType.value || x.name == this.field.detailObject.taxType.value) : null;

        var defaultCurrency = baseCurrency;
        var defaultTaxType = taxStatuses.find(x => x.name == TaxStatusEnum.Inclusive);

        var finalCurrency = this.field.detailObject.editableCurrency ? incomingCurrencyObject || currentCurrency || defaultCurrency : currentCurrency || defaultCurrency;
        var finalAmount = parseFloat(incomingAmountValue);
        var finalTaxType = incomingTaxType || currentTaxType || defaultTaxType;

        if (finalTaxType.name == TaxStatusEnum.Auction || finalTaxType.name == TaxStatusEnum.Tender || finalTaxType.name == TaxStatusEnum.POA)
        {
            this.formattedValueForEdit = finalTaxType.reference;
            finalAmount = 0;
        }
        else
        {
            if (!this.field.allowZero && !finalAmount)
            {
                this.formattedValueForEdit = '';
                finalAmount = null;
            }
            else
            {
                this.formattedValueForEdit = `${finalCurrency.reference.toUpperCase()} ${finalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${finalTaxType.reference}`;
            }
        }

        if (this.ionInput) {
            this.ionInput.value = this.formattedValueForEdit;
        }
        if (this.field && this.field.detailObject) {
            if (this.field.detailObject.currency) this.field.detailObject.currency.value = finalCurrency.currencyId;
            this.field.detailObject.taxType.value = finalTaxType.taxStatusEnum;
            this.field.detailObject.price.value = (finalAmount == 0 || finalAmount) ? parseFloat(finalAmount.toFixed(2)) : null;
        }

        this.priceTaxTypeLabel = finalTaxType.name || "";
        this.priceEditorObject = this.field.detailObject;
        this.formattedValue = this.formattedValueForEdit;
        this.ref.detectChanges();
        return (finalAmount == 0 || finalAmount) ? parseFloat(finalAmount.toFixed(2)) : null;

    }


    parseCurrencyTaxInput(input: string) {
        const regex = /^([a-zA-Z]{1,3})?\s*(-?[0-9,]*\.?[0-9]*)?\s*([a-zA-Z ]+)?$/;
        const match = input.trim().match(regex);

        let incomingCurrencyInput = null
        let incomingCurrencyCode = null;
        let incomingAmount = null;
        let incomingTaxTypeInput = null;
        let incomingTaxTypeCode = null;

        if (match) {
            incomingCurrencyInput = match[1] || null;
            incomingAmount = match[2] ? parseFloat(match[2].replace(/,/g, '')) : 0;
            incomingTaxTypeInput = match[3] || null;
        }

        if (incomingCurrencyInput)
        {
            incomingCurrencyCode = this.currencyCodes[incomingCurrencyInput.toLowerCase()] || null;
        }

        if (incomingTaxTypeInput)
        {
            incomingTaxTypeCode = this.taxTypeCodes[incomingTaxTypeInput.toLowerCase()] || null;
        }

        if (incomingCurrencyInput && !incomingAmount && !incomingTaxTypeInput && !incomingCurrencyCode && !incomingTaxTypeCode)
        {
            //Potentially only the tax type was entered
            incomingTaxTypeCode = this.taxTypeCodes[incomingCurrencyInput.toLowerCase()] || null;
        }

        return { incomingCurrencyCode, incomingAmount, incomingTaxTypeCode };
    }

    selectAll()
    {
        if (this.ionInput && this.ionInput.getInputElement) {
            this.ionInput.getInputElement().then((input: HTMLInputElement) => {
                input.select();
            });
        }
    }

    convertPriceToEditableFormat()
    {
        this.selectAll()

        const value = this.formattedValueForEdit?.trim();
        if (!value) return '';

        if (/^(POA|Auction|Tender)$/i.test(value)) {
            const taxShort = Object.keys(this.taxTypeCodes).find(
                key => this.taxTypeCodes[key].toLowerCase() === value.toLowerCase() && key.length === 1
            ) || value[0].toLowerCase();
            return taxShort;
        }

        const regex = /^([A-Za-z]{1,3})\s*(-?[\d,]+\.\d{2})\s*([A-Za-z ]+)$/;
        const match = value.match(regex);

        if (!match) return '';

        let currency = match[1].toUpperCase();
        let amount = match[2].replace(/,/g, '');
        let taxType = match[3].trim().toLowerCase();

        let currencyShort = Object.keys(this.currencyCodes).find(
            key => this.currencyCodes[key] === currency && key.length === 1
        ) || currency[0].toLowerCase();

        let taxShort = Object.keys(this.taxTypeCodes).find(
            key => this.taxTypeCodes[key] === taxType && key.length === 1
        ) || taxType[0];

        this.formattedValueForEdit = `${currencyShort}${amount}${taxShort}`;
    }

    currencyCodes = {
        n: 'NZD',
        a: 'AUD',
        p: 'GBP',
        c: 'CAD',
        e: 'EUR',
        y: 'JPY',
        u: 'USD',
        NZD: 'NZD',
        AUD: 'AUD',
        GBP: 'GBP',
        CAD: 'CAD',
        EUR: 'EUR',
        JPY: 'JPY',
        USD: 'USD',
    };

    taxTypeCodes = {
        i: 'incl',
        e: 'excl',
        x: 'xmpt',
        n: 'nreg',
        oi: 'ovr incl',
        oe: 'ovr excl',
        z: 'zero',
        a: 'all gst',
        t: 'tender',
        po: 'poa',
        au: 'auction',
        incl: 'incl',
        excl: 'excl',
        xmpt: 'xmpt',
        nreg: 'nreg',
        'ovr incl': 'ovr incl',
        'ovr excl': 'ovr excl',
        zero: 'zero',
        'all gst': 'all gst',
        tender: 'tender',
        poa: 'poa',
        auction: 'auction',
    };

    onDatePickerChanged(ev: { startDate: Date, endDate: Date, timePeriod: TimePeriodDropDownType })
    {
        if (this.field.type !== 'date-picker') return;

        // detailObject now ONLY holds the period enum/string
        this.field.detailObject = ev.timePeriod;

        // value holds the actual Date objects
        this.field.value = {
            startDate: ev.startDate,
            endDate: ev.endDate
        };

        this.field.dirty = true;
        this.field.invalid = !this.fieldIsValid();
        this.formatValueForView();

        this.changed.emit({
            detail: {
                id: this.field.id,
                field: this.field,
                value: this.field.value,
                event: ev
            }
        });
        this.ref.markForCheck();
    }

    async getTextareaSelection(): Promise<{ start: number; end: number; selectedText: string }> {
        if (!this.ionTextArea) return { start: -1, end: -1, selectedText: '' };

        const el = await this.ionTextArea.getInputElement();
        if (!el) return { start: -1, end: -1, selectedText: '' };

        const start = el.selectionStart ?? 0;
        const end = el.selectionEnd ?? start;
        const value = el.value ?? '';
        const selectedText = start !== end ? value.substring(start, end) : '';

        return { start, end, selectedText };
    }

    async onTextareaEvent()
    {
        const sel = await this.getTextareaSelection();
        this.field.textSelectionStart = sel.start;
        this.field.textSelectionEnd = sel.end;
        this.field.textSelectedText = sel.selectedText;        
    }
}
